<div class="bg-primary d-inline-flex fixed-bottom pt-1 pb-1 justify-content-around d-block d-md-none">
    <a>     
        <span routerLink="/portal" routerLinkActive="active-icon" class="material-icons footer-icon text-center">
        home
        </span>
    </a>
    <a>      
        <span routerLink="/people" routerLinkActive="active-icon" class="material-icons footer-icon text-center f-35">
        people_alt
        </span>
    </a>
    <a>    
        <span routerLink="/customers" routerLinkActive="active-icon" class="material-icons footer-icon text-center f-35">
        business
        </span>
    </a>
    </div>

    